import React, { Component } from 'react'
import styles from './gs_calendar_style'
import moment from 'moment-timezone'
import { withStyles } from '@material-ui/core/styles'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import Calendar from './calendar'
import { Box } from '@material-ui/core'

class CalenderWith3Month extends Component {
  constructor(props) {
    super(props)
    const startDate = props.startDate ? moment(props.startDate, 'MM-DD-YYYY').format('MM-DD-YYYY') : moment().format('MM-DD-YYYY')
    this.state = {
      startDate: startDate,
      endDate: props.endDate ? moment(props.endDate, 'MM-DD-YYYY').format('MM-DD-YYYY') : moment().format('MM-DD-YYYY'),
      currentMonth: moment(startDate, 'MM-DD-YYYY').add(1, 'month').format('MM-DD-YYYY'),
      EventsList: props.EventsList || [],
      firstDate: moment.tz(props.timeZone).startOf('month').format('MM-DD-YYYY')
    }
    this.calendarFormat = 'MM-DD-YYYY'
  }

  static getDerivedStateFromProps(props, state) {
    let startDate = props.startDate
    let endDate = props.endDate
    let EventsList = props.EventsList || []

    if (startDate !== state.startDate || endDate !== state.endDate || EventsList.length !== state.EventsList.length) {
      return {
        EventsList: EventsList,
        startDate: startDate,
        endDate: endDate,
        currentMonth: moment(startDate, 'MM-DD-YYYY').add(1, 'month').format('MM-DD-YYYY')
      }
    }

    return null
  }

  nextMonth = () => {
    let nextMonthDate = moment(this.state.currentMonth, this.calendarFormat).add(1, 'month').format(this.calendarFormat)
    if (moment(nextMonthDate, this.calendarFormat).isBefore(moment(this.state.endDate, this.calendarFormat), 'month')) {
      this.setState({
        currentMonth: moment(this.state.currentMonth, this.calendarFormat).add(1, 'month').format(this.calendarFormat)
      })
    }
  };

  prevMonth = () => {
    let lastMonthDate = moment(this.state.currentMonth, this.calendarFormat).subtract(1, 'month').format(this.calendarFormat)
    if (moment(lastMonthDate, this.calendarFormat).isAfter(moment(this.state.startDate, this.calendarFormat), 'month')) {
      this.setState({
        currentMonth: lastMonthDate
      })
    }
  };

  renderDefaultCalendar = () => {
    const { classes, startDate, endDate, timeZone, programId, enrollmentDate } = this.props
    let currentMonthDate = this.state.currentMonth
    let prevMonthDate = moment(currentMonthDate, this.calendarFormat).subtract(1, 'month').format(this.calendarFormat)
    let nextMonthDate = moment(currentMonthDate, this.calendarFormat).add(1, 'month').format(this.calendarFormat)
    const shouldDisplayPrevMonth = moment(startDate, this.calendarFormat).isSameOrBefore(moment(prevMonthDate, this.calendarFormat).tz(timeZone), 'month')
    const shouldDisplayCurrentMonth = moment(endDate, this.calendarFormat).isSameOrAfter(moment(currentMonthDate, this.calendarFormat).tz(timeZone), 'month')
    const shouldDisplayNextMonth = moment(endDate, this.calendarFormat).isSameOrAfter(moment(nextMonthDate, this.calendarFormat).tz(timeZone), 'month') && moment(nextMonthDate, this.calendarFormat).isSameOrBefore(moment().tz(timeZone), 'month')
    const shouldDisplayPrev = moment(startDate, this.calendarFormat).isBefore(moment(prevMonthDate, this.calendarFormat).tz(timeZone), 'month')
    const shouldDisplayNext = moment(endDate, this.calendarFormat).isAfter(moment(nextMonthDate, this.calendarFormat).tz(timeZone), 'month') && moment(nextMonthDate, this.calendarFormat).isSameOrBefore(moment().tz(timeZone), 'month')

    return (
      <div className={classes.row}>
        {shouldDisplayPrev && <div className={classes.sideArrowBar} onClick={this.prevMonth}>
          <div className={classes.arrowIcon}><ArrowBackIosIcon /></div>
        </div>}
        {shouldDisplayPrevMonth && <div className={`${classes.col} ${classes.colPad}`}>
          <Calendar classes={{ calendar: { width: '33%' } }} currentMonth={prevMonthDate} EventsList={this.state.EventsList} timeZone={timeZone || ''} programId={programId} enrollmentDate={enrollmentDate} />
        </div>}
        {shouldDisplayCurrentMonth && <div className={`${classes.col} ${classes.colPad}`}>
          <Calendar currentMonth={currentMonthDate} EventsList={this.state.EventsList} timeZone={timeZone || ''} programId={programId} enrollmentDate={enrollmentDate} />
        </div>}
        {shouldDisplayNextMonth && <div className={`${classes.col} ${classes.colPad}`}>
          <Calendar currentMonth={nextMonthDate} EventsList={this.state.EventsList} timeZone={timeZone || ''} programId={programId} enrollmentDate={enrollmentDate} />
        </div>}
        {shouldDisplayNext && <div className={classes.sideArrowBar} onClick={this.nextMonth}>
          <div className={classes.arrowIcon}><ArrowForwardIosIcon /></div>
        </div>}
      </div>
    )
  }

  handlePrevClick = () => {
    const { timeZone } = this.props
    const modifiedDate = moment.tz(this.state.firstDate, this.calendarFormat, timeZone).subtract(1, 'month').format(this.calendarFormat)
    this.setState({ firstDate: modifiedDate })
  }

  handleNextClick = () => {
    const { timeZone } = this.props
    const modifiedDate = moment.tz(this.state.firstDate, this.calendarFormat, timeZone).add(1, 'month').format(this.calendarFormat)
    this.setState({ firstDate: modifiedDate })
  }

  renderEventCalendar = () => {
    const calendarList = []
    const { classes, timeZone, programId } = this.props
    const { firstDate } = this.state

    calendarList.push({
      month: firstDate
    }, {
      month: moment.tz(firstDate, this.calendarFormat, timeZone).add(1, 'month').format(this.calendarFormat)
    }, {
      month: moment.tz(firstDate, this.calendarFormat, timeZone).add(2, 'month').format(this.calendarFormat)
    }, {
      month: moment.tz(firstDate, this.calendarFormat, timeZone).add(3, 'month').format(this.calendarFormat)
    })

    return (
      <Box className={classes.wrapper}>
        <div className={classes.icon} onClick={() => { this.handlePrevClick(); this.props.onPrevious && this.props.onPrevious() }}><ArrowBackIosIcon /></div>
        <Box className={`${classes.row} ${classes.calendarWrapper}`}>
          {calendarList.map(obj => (
            <Box className={calendarList.length > 1 ? classes.halfWidth : classes.fullWidth}>
              <Calendar currentMonth={obj.month} EventsList={this.props.EventsList} timeZone={timeZone || ''} programId={programId} eventsCount={this.props.eventCount} getEvents={this.props.getEvents} page='Event' />
            </Box>
          ))}
        </Box>
        <div className={classes.icon} onClick={() => { this.handleNextClick(); this.props.onNext && this.props.onNext() }}><ArrowForwardIosIcon /></div>
      </Box>
    )
  }

  render() {

    return (
      this.props.view === 3
        ? (this.renderDefaultCalendar())
        : (this.renderEventCalendar())
    )
  }
}

CalenderWith3Month.defaultProps = {
  view: 3
}

export default (withStyles(styles)(CalenderWith3Month))